/**
 * TanStack Query hooks for `gamification`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	gamificationQueryKeys,
	type CreateGamificationBody,
	type ListGamificationResponse,
	type GamificationRow,
} from "./api";

export function useGamificationList(): UseQueryResult<ListGamificationResponse, Error> {
	return useQuery({
		queryKey: gamificationQueryKeys.list(),
		queryFn: list,
	});
}

export function useGamificationCreate(): UseMutationResult<GamificationRow, Error, CreateGamificationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gamificationQueryKeys.all });
		},
	});
}

export function useGamificationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gamificationQueryKeys.all });
		},
	});
}
